import type {Cta, DownloadMenu, ThemedVisual} from '../../../Index.types'
import {BackgroundGrid} from '../BackgroundGrid/BackgroundGrid'

import Styles from './Showcase.module.css'

export interface ShowcaseProps {
  title: string
  description: string
  cta1: DownloadMenu
  cta2: Cta
  visual: ThemedVisual
}

export const defaultProps: Partial<ShowcaseProps> = {}

export const Showcase = (props: ShowcaseProps) => {
  const initializedProps: ShowcaseProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return (
    <div className={Styles['Showcase']}>
      <BackgroundGrid />
    </div>
  )
}
